import styled from "styled-components";
import "@fontsource/open-sans";
import { appearModal } from "../../constants/animationConstants";

export const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 200px;
  width: 290px;
  height: 244px;
  background-color: white;
  padding-top: 25px;
  border-radius: 8px;
  box-shadow: 0 10px 32px 0 rgba(113, 101, 227, 0.2),
    0 10px 32px 0 rgba(113, 101, 227, 0.2);
  animation: ${appearModal} .2s linear;

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row-reverse;
    width: 550px;
    height: 200px;
    padding-left: 40px;
    bottom: 240px;
    left: -100px;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 900;
  line-height: 36px;
  letter-spacing: 0.04em;
  text-align: center;
  color: #7165e3;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    text-align: right;
  }
`;

export const Text = styled.p`
  font-family: "Open Sans";
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #818c9b;
`;

export const Image = styled.img`
  width: 174px;
  display: block;
  margin: auto;
  margin-top: -10px;

  @media (min-width: 768px) {
    width: 230px;
    margin: 0;
    margin-top: -25px;
  }
`;
